import { IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY } from '@atlassian/jira-common-constants/src/project-template-type-keys';
import { fg } from '@atlassian/jira-feature-gating';
import { PREMIUM_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const useShouldPromptJsmTrial = ({ templateKey }: { templateKey: string }) => {
	const { serviceDesk } = useAppEditions();

	return {
		shouldPromptJsmTrial:
			serviceDesk !== PREMIUM_EDITION &&
			templateKey === IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY &&
			fg('jsm_it_service_management_advanced_template'),
	};
};
